import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import CMHK from './modules/CMHK'

Vue.use(Vuex)

const _store = new Vuex.Store({
    modules: {
        app,
        user,
        CMHK,
    },
})

export default _store
